export default "__VITE_ASSET__C4KH$3o7__"